import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ParkingPass as ParkingPassModel } from 'models/parking-passes';

import DropoffInstructions from 'components/parking-passes/parking-instructions/pricing-instructions/dropoff-instructions';
import PickupInstructions from 'components/parking-passes/parking-instructions/pricing-instructions/pickup-instructions';

const propTypes = {
  parkingPass: PropTypes.instanceOf(ParkingPassModel).isRequired,
};

const PricingInstructions = ({ parkingPass }) => (
  <Fragment>
    <DropoffInstructions instructions={parkingPass.dropoffInstructions} /> 
    <PickupInstructions instructions={parkingPass.pickupInstructions} />
  </Fragment>
);

PricingInstructions.propTypes = propTypes;
export default PricingInstructions;
